import moment from 'moment';
import {
  getLength, calculateAgeInYears, checkValidRange, patternCheck,
} from '../utils/util';
import { validateTransferPoints } from './CustomValidations/mrtJapanValidations';

const getVal = require('lodash/get');

/* eslint-disable max-params -- need */
const compareValues = (value, validation, dataObject, comparisonType) => {
  let valueToCompare = validation.selectKey
    ? getVal(dataObject, validation.selectKey) : validation.staticValue;
  value = patternCheck(value);
  valueToCompare = patternCheck(valueToCompare);

  let parsedValue = Number(value);
  let parsedValueToCompare = Number(valueToCompare);
  if (Number.isNaN(parsedValue) && Number.isNaN(parsedValueToCompare)) {
    // both the values are strings
    parsedValue = value;
    parsedValueToCompare = valueToCompare;
  }

  if (comparisonType === 'valueLessOrEqualThan' && parsedValue > parsedValueToCompare) {
    return false;
  }
  if (comparisonType === 'valueLessThan' && parsedValue >= parsedValueToCompare) {
    return false;
  }
  if (comparisonType === 'compareValue' && parsedValue !== parsedValueToCompare) {
    return false;
  }
  if (comparisonType === 'valueGreaterThanEqual' && parsedValue < parsedValueToCompare) {
    return false;
  }
  if (comparisonType === 'valueRemainderEqualToZero' && (parsedValue % parsedValueToCompare) !== 0) {
    return false;
  }
  return true;
};
/* eslint-enable max-params -- need */

/* eslint-disable max-len -- need */
export const validateDlsInput = (inputValue, validations, dataObject = {}) => {
  // iterate over validations and validate input for every validation
  let isValid = true;
  let invalidMsg = '';

  validations.forEach((validation) => {
    if (isValid) {
      switch (validation.type) {
        case 'mandatoryField':
          {
            const { isFieldRequired = true } = dataObject;
            if (!inputValue && isFieldRequired) {
              isValid = false;
              invalidMsg = validation.onInvalidMsg;
            }
          }
          break;
        case 'inputLengths':
          {
            const length = getLength(inputValue.trim());
            if (inputValue && validation.minLength && length < validation.minLength) {
              isValid = false;
              invalidMsg = validation.onInvalidMinLengthMsg;
            }
            if (inputValue && validation.maxLength && length > validation.maxLength) {
              isValid = false;
              invalidMsg = validation.onInvalidMaxLengthMsg;
            }
          }
          break;
        case 'SSN':
          {
            const rexString = /^(?!666|000|9\d{2})\d{3}([ -]?)(?!00)\d{2}([ -]?)(?!0{4})\d{4}$/;
            if (!rexString.test(inputValue)) {
              isValid = false;
              invalidMsg = validation.onInvalidMsg;
            }
          }
          break;
        case 'ITIN':
          {
            const rexString = /^(9\d{2})([ -]?)((5\d|6[0-5])|(8[3-8])|(9[0-2])|(9[4-9]))([ -]?)\d{4}$/;
            if (!rexString.test(inputValue)) {
              isValid = false;
              invalidMsg = validation.onInvalidMsg;
            }
          }
          break;
        case 'validateAgainstRegex':
          {
            const rex = new RegExp(validation.rexString);
            if (inputValue && inputValue.length > 0 && !rex.test(inputValue)) {
              isValid = false;
              invalidMsg = validation.onInvalidMsg;
            }
          }
          break;
        case 'validateCardNumberFormat':
          if (inputValue) {
            // remove any spaces or dashes present
            const cardNumber = inputValue.replace(/-|\s/g, '');
            const data = [];
            let tmpData; let checkDigit; let
              check;
            let total = 0;
            if (cardNumber.length !== 15) {
              isValid = false;
              invalidMsg = validation.onInvalidMsg;
            } else {
              tmpData = cardNumber;
              checkDigit = tmpData % 10;
              tmpData = Number.parseInt(tmpData / 10, 10);

              for (let i = 0; i < 14; i += 1) {
                data[i] = tmpData % 10;
                tmpData = Number.parseInt(tmpData / 10, 10);
                if (i % 2 === 0) {
                  data[i] *= 2;
                }
                total = total + (data[i] % 10) + Number.parseInt(data[i] / 10, 10);
              }

              check = (10 - (total % 10)) % 10;
              if (check !== checkDigit) {
                isValid = false;
                invalidMsg = validation.onInvalidMsg;
              }
            }
          }
          break;
        case 'dynamicValidation': {
          {
            const rexObject = validation.mapValues;
            let dependsID;
            validation.IDs.forEach((id) => {
              if (id in dataObject.filledFormData) {
                dependsID = dataObject.filledFormData[id];
              }
              if (dependsID in rexObject) {
                const rex = new RegExp(rexObject[dependsID]);
                if (inputValue.length > 0 && !rex.test(inputValue)) {
                  isValid = false;
                  invalidMsg = validation.onInvalidMsg;
                }
              }
            });
          }
          break;
        }
        case 'validateAgainstAllowedRanges':
          if (inputValue) {
            // remove any spaces or dashes present
            const trimmedInputVal = inputValue.replace(/-|\s/g, '');
            const { allowedRanges, from, to } = validation;
            const subStringRange = { from, to };
            const isValidRange = checkValidRange(trimmedInputVal, allowedRanges, subStringRange);
            if (!isValidRange) {
              isValid = false;
              invalidMsg = validation.onInvalidMsg;
            }
          }
          break;
        case 'valueGreaterThan': {
          if (inputValue) {
            // validation.valueToCompare should be a number - INT/FLOAT
            const value = Number.parseFloat(inputValue.replace(/,/g, ''));
            if (value <= validation.valueToCompare) {
              isValid = false;
              invalidMsg = validation.onInvalidMsg;
            }
          }
          break;
        }
        case 'compareValue':
        case 'valueLessOrEqualThan':
        case 'valueLessThan':
        case 'valueRemainderEqualToZero':
        case 'valueGreaterThanEqual': {
          if (inputValue) {
            isValid = compareValues(inputValue, validation, dataObject, validation.type);
            if (!isValid) {
              invalidMsg = validation.onInvalidMsg;
            }
          }
          break;
        }
        case 'validateAgainstDynamicRegex':
        {
          // Regex will be picked dynamically based on values of some other fields
          const { regexMappings } = validation;
          // regexMappings are the fieldIds which we have to check if present in the dataObject and if yes, pick the regex corresponding to the fieldId value
          isValid = true;
          /* eslint-disable no-restricted-syntax -- need */
          for (const fieldId of Object.keys(regexMappings)) {
            if (fieldId in dataObject.formSubmissionPayload
                && Object.prototype.hasOwnProperty.call(regexMappings[fieldId], dataObject.formSubmissionPayload[fieldId])) {
              const rex = new RegExp(regexMappings[fieldId][dataObject.formSubmissionPayload[fieldId]]);
              if (!rex.test(inputValue)) {
                isValid = false;
                invalidMsg = validation.onInvalidMsg[fieldId];
                break;
              }
            }
          }
          /* eslint-enable no-restricted-syntax -- need */
          break;
        }
        case 'multiplesOf': {
          if (inputValue) {
            const multiplesOfValue = validation.selectKey ? getVal(dataObject, validation.selectKey) : validation.staticValue;
            const value = Number.parseFloat(inputValue.replace(/,/g, ''));
            if (value % Number(multiplesOfValue) !== 0) {
              isValid = false;
              invalidMsg = validation.onInvalidMsg;
            }
          }
          break;
        }
        case 'validateJP_MRT_TransferPoints': {
          // custom logic and mappings for JP_MRT_TransferPoints
          if (inputValue) {
            const errorMessage = validateTransferPoints(Number(inputValue), dataObject);
            if (errorMessage) {
              isValid = false;
              invalidMsg = errorMessage;
            }
          }
          break;
        }
        case 'isUniqueValue': {
          // Custom validation logic if we have to restrict the current field if it is having a duplicate value
          if (inputValue) {
            const { selectKey, valueToCompare } = validation;
            const selectedData = getVal(dataObject, selectKey);
            let isValueExists = false;
            if (selectedData && Array.isArray(selectedData)) {
              isValueExists = selectedData.some((data) => inputValue === data[valueToCompare]);
            }
            if (isValueExists) {
              isValid = false;
              invalidMsg = validation.onInvalidMsg;
            }
          }
          break;
        }
        case 'isAllSame': {
          if (inputValue) {
            const { selectKey, valueToCompare } = validation;
            const selectedData = getVal(dataObject, selectKey);
            if (
              selectedData
              && Array.isArray(selectedData)
              && selectedData.length > 0
            ) {
              const firstInput = selectedData[0]?.[valueToCompare];
              if (firstInput && inputValue !== firstInput) {
                isValid = false;
                invalidMsg = validation.onInvalidMsg;
              }
            }
          }
          break;
        }
        case 'validateConsecutiveDigits': {
          if (inputValue) {
            const digits = [...inputValue.toString()].map(Number);
            let isValidDigit = true;
            const { checkLength } = validation;
            for (let i = 0; i <= digits.length - checkLength; i += 1) {
              let inc = true;
              let dec = true;

              for (let j = 1; j < checkLength; j += 1) {
                if (digits[i + j] !== digits[i + j - 1] + 1) inc = false;
                if (digits[i + j] !== digits[i + j - 1] - 1) dec = false;
              }
              if (inc || dec) {
                isValidDigit = false;
              }
            }
            if (!isValidDigit) {
              isValid = false;
              invalidMsg = validation.onInvalidMsg;
            }
          }
          break;
        }
        case 'validatePCNPeriod': {
          if (inputValue) {
            const { minAllowedPeriod } = validation;
            if (minAllowedPeriod) {
              const year = inputValue.slice(0, 4);
              const day = inputValue.slice(4, 7);
              const pcnDate = moment(year, 'YYYY').add(Number(day) - 1, 'days').startOf('day');
              const today = moment().startOf('day');
              const minAllowedDate = today.clone().subtract(minAllowedPeriod, 'days');

              if (pcnDate.isBefore(minAllowedDate) || pcnDate.isAfter(today)) {
                isValid = false;
                invalidMsg = validation.onInvalidMsg;
              }
            }
          }
          break;
        }
        default:
      }
    }
  });
  return invalidMsg;
};

export const validateCheckbox = (inputValue, validations, dataObject = {}) => {
  // iterate over validations and validate input for every validation
  let isValid = true;
  let invalidMsg = '';

  validations.forEach((validation) => {
    if (isValid) {
      switch (validation.type) {
        case 'mandatoryField':
          {
            const { isFieldRequired = true } = dataObject;
            if (!inputValue && isFieldRequired) {
              isValid = false;
              invalidMsg = validation.onInvalidMsg;
            }
          }
          break;
        default:
      }
    }
  });
  return invalidMsg;
};

export const validateDateRangeSelector = (params) => {
  // startDate and endDate are strings
  const {
    startDate, endDate, validations, dateIds, dateFormat,
  } = params;
  let validationStatus = {
    invalidMsg: '',
    elementToFocus: '',
  };
  // return invalida message and element to focus on if any validation fails
  validations.forEach((validation) => {
    if (!validationStatus.invalidMsg) {
      switch (validation.type) {
        case 'mandatoryField':
          if (!startDate || !endDate) {
            validationStatus = {
              invalidMsg: validation.onInvalidMsg,
              elementToFocus: !startDate ? dateIds.start : dateIds.end,
            };
          }
          break;
        case 'startDateGreaterThanEndDate':
          if (startDate && endDate && (new Date(startDate) > new Date(endDate))) {
            validationStatus = {
              invalidMsg: validation.onInvalidMsg,
              elementToFocus: dateIds.start,
            };
          }
          break;
        case 'allowedRangeInDays':
          if (startDate && endDate) {
            const oneDay = 24 * 60 * 60 * 1000;
            const firstDate = new Date(startDate);
            const secondDate = new Date(endDate);
            const daysIntheRange = Math.round(Math.abs((firstDate - secondDate) / oneDay));
            if (validation.maxAllowedRange && daysIntheRange > validation.maxAllowedRange) {
              validationStatus = {
                invalidMsg: validation.invalidMaxAllowedRangeMsg,
                elementToFocus: dateIds.start,
              };
            } else if (validation.minAllowedRange && daysIntheRange < validation.minAllowedRange) {
              validationStatus = {
                invalidMsg: validation.minAllowedRangeMsg,
                elementToFocus: dateIds.start,
              };
            } else {
              validationStatus = { invalidMsg: '', elementToFocus: '' };
            }
          }
          break;
        case 'minimumStartDateFromToday':
          if (startDate) {
            const today = new Date();
            const minStartDate = new Date(today);
            minStartDate.setDate(today.getDate() + validation.minDays);
            if (new Date(moment(startDate, dateFormat).format('YYYY-MM-DD')) < minStartDate) {
              validationStatus = {
                invalidMsg: validation.onInvalidMsg,
                elementToFocus: dateIds.start,
              };
            }
          }
          break;
        default: validationStatus = { invalidMsg: '', elementToFocus: '' };
      }
    }
  });
  return validationStatus;
};

export const validateDateSelector = (
  validations,
  curSelectedDate,
  {
    dateFormat,
    dataObject,
  }
) => {
  const rexParam = '\\d{1,2}/\\d{1,2}/\\d{4}';
  const today = new Date();
  const selection = curSelectedDate && curSelectedDate.dateString
    ? moment(curSelectedDate.dateString, dateFormat).toDate()
    : null;
  const rex = new RegExp(rexParam);
  const isValidDate = (dateString, format) => moment(dateString, format, true).isValid();
  let isCurSelectionValid = true;
  let invalidMsg = '';

  /* eslint complexity: ["error", 80] -- need to increase complexity */
  validations.forEach((validation) => {
    if (isCurSelectionValid) {
      switch (validation.type) {
        case 'mandatoryField':
          if (!selection) {
            invalidMsg = validation.onInvalidMsg;
            isCurSelectionValid = false;
          }
          break;
        case 'invalidDate':
          if (selection) {
            const validFormat = dateFormat ? isValidDate(curSelectedDate.dateString, dateFormat)
              : selection.getTime() && rex.test(curSelectedDate.dateString);
            if (!validFormat) {
              invalidMsg = validation.onInvalidMsg;
              isCurSelectionValid = false;
            }
          }
          break;
        case 'futureDate':
          if (selection && selection.getTime() <= today.getTime()) {
            invalidMsg = validation.onInvalidMsg;
            isCurSelectionValid = false;
          }
          break;
        case 'fromCurrentDate':
          today.setHours(0);
          today.setMinutes(0);
          today.setSeconds(0);
          today.setMilliseconds(0);
          if (selection && selection.getTime() < today.getTime()) {
            invalidMsg = validation.onInvalidMsg;
            isCurSelectionValid = false;
          }
          break;
        case 'pastDate':
          if (selection && selection.getTime() >= today.getTime()) {
            invalidMsg = validation.onInvalidMsg;
            isCurSelectionValid = false;
          }
          break;
        case 'dateInRange':
          if (selection) {
            const minDate = new Date();
            minDate.setDate(minDate.getDate() + validation.greaterThan);
            const maxDate = new Date();
            maxDate.setDate(maxDate.getDate() + validation.lessThan);
            if (selection < minDate || selection > maxDate) {
              isCurSelectionValid = false;
              invalidMsg = validation.onInvalidMsg;
            }
          }
          break;
        case 'calculateAgeInYears':
          if (selection) {
            const age = calculateAgeInYears(selection);
            if ((validation.greaterThan && validation.greaterThan > age)
              || (validation.lessThan && validation.lessThan < age)) {
              invalidMsg = validation.onInvalidMsg;
              isCurSelectionValid = false;
            }
          }
          break;
        case 'compareWithPreviousDate':
          if (selection) {
            const prevDateString = validation.selectKey
              ? getVal(dataObject, validation.selectKey) : validation.staticValue || '';
            if (prevDateString) {
              const prevDate = moment(prevDateString, dateFormat).toDate();
              if (validation.comparison) {
                const adjustment = validation[validation.comparison] || 0;
                prevDate.setDate(
                  validation.comparison === 'greaterThan'
                    ? prevDate.getDate() + adjustment
                    : prevDate.getDate() - adjustment);
                const isInvalid = validation.comparison === 'greaterThan' ? selection < prevDate : selection > prevDate;

                if (isInvalid) {
                  isCurSelectionValid = false;
                  invalidMsg = validation.onInvalidMsg;
                }
              }
            }
          }
          break;
        default:
      }
    }
  });
  return invalidMsg;
};
/* eslint-enable max-len -- need */

export const checkDependentValidations = (element, values) => {
  if (!element.dependentFieldsValidation) return {};

  return element.dependentFieldsValidation.reduce((errorIds, validation) => {
    const nonEmptyFieldsCount = validation.fields.reduce(
      (count, field) => (values[field] && (values[field] !== '' && values[field] !== 'Off' && values[field] !== 'No') ? count + 1 : count),
      0
    );

    errorIds[validation.errorMessageId] = nonEmptyFieldsCount >= validation.requiredField;
    return errorIds;
  }, {});
};
